// eslint-disable-next-line
import Symbol_observable from 'symbol-observable';
import { ColorModeScript } from '@chakra-ui/react';
import { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import * as Sentry from '@sentry/react';

import App from './App';
import Error from './Components/Error';
import Loginpage from './Pages/Login';
import Auth from './Components/Auth';
import Layout from './Layouts';
import routes from './routes';
import SignupPage from './Pages/Signup';

Sentry.init({
  dsn: import.meta.env.VITE_APP_SENTRY_DSN,
  environment: import.meta.env.VITE_APP_SENTRY_ENVIRONMENT || 'dev',
  // eslint-disable-next-line no-undef
  release: __VITE_APP_RELEASE__,
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  tracesSampleRate: 1.0,
  normalizeDepth: 6,
});

const container = document.getElementById('root');
const root = ReactDOM.createRoot(container);

const router = createBrowserRouter([
  {
    path: '/',
    element: <App />,
    errorElement: <Error />,
    children: [
      {
        path: 'login',
        element: <Loginpage />,
      },
      {
        path: 'signup',
        element: <SignupPage />,
      },
      {
        path: '',
        element: <Auth><Layout /></Auth>,
        children: routes,
      },
    ],
  },
]);

root.render(
  <StrictMode>
    <ColorModeScript />
    <RouterProvider router={router} />
  </StrictMode>,
);
